import { ethers } from "ethers";
/** Canonical 32-byte base58 encoding. The quote server additionally requires
 * an on-curve wallet, before any proof or submission is prepared. */
/** Checksummed, nonzero EVM wallet for CCIP destinations. */
export function evmWalletAddress(address: string): string {
  if (!ethers.isAddress(address) || BigInt(address) < 1024n)
    throw Error("Invalid Ethereum wallet");
  return ethers.getAddress(address);
}
export function solanaWalletBytes(address: string): string {
  if (!/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(address))
    throw Error("Invalid Solana wallet");
  const value = ethers.decodeBase58(address);
  if (value === 0n) throw Error("Invalid Solana wallet");
  const bytes = ethers.toBeHex(value, 32);
  if (ethers.encodeBase58(ethers.getBytes(bytes)) !== address)
    throw Error("Invalid Solana wallet");
  return bytes;
}
